module.exports = __webpack_public_path__ + "static/media/email-mobile.9a3d3063.svg";